module.exports = __webpack_public_path__ + "img/brand-02.179dc5f5.png";